/*
* Returns the actual content width within an node, ignoring its
* parent container styling
*/
export default function getActualContentWidth (node) {
  if (!node) {
    return 0
  }

  // Save the original styles to restore them later
  const originalStyle = {
    display: node.style.display,
    position: node.style.position,
    visibility: node.style.visibility,
    whiteSpace: node.style.whiteSpace,
  }

  // Temporarily apply styles to measure the actual content width
  node.style.display = 'inline-block'
  node.style.position = 'absolute'
  node.style.visibility = 'hidden'
  node.style.whiteSpace = 'nowrap' // Prevent wrapping to measure true width

  // Get the width of the content
  const width = node.getBoundingClientRect().width

  // Restore the original styles
  node.style.display = originalStyle.display
  node.style.position = originalStyle.position
  node.style.visibility = originalStyle.visibility
  node.style.whiteSpace = originalStyle.whiteSpace

  return width
}
